

/**
 * @name OperatorNotificationPrefs
 * @description The OperatorNotificationPrefs service
 * @param {library} $http Angular $http
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} AlertMessages The AlertMessages service
 * @param {library} _ The lodash library
 * @return {service} Returns the service
 */
function OperatorNotificationPrefs(
  $http,
  ENDPOINT,
  Session,
  moment,
  AlertMessages,
  _
) {
  // Public Functions
  OperatorNotificationPrefs.get = get;
  OperatorNotificationPrefs.create = create;
  OperatorNotificationPrefs.update = update;

  /**
   * @name getArtistPrefs
   * @description Function to retrieve artist notification preferences
   * @param {number} id The ID of the preferences to retrieve
   * @return {object} Returns the notification preferences objdect
   */
  function get(id) {
    return $http.get(ENDPOINT.server +
    'collectors/api/v1.1/email/operator-preference/' + id + '/')
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create notification preferences for artists
   * @return {object} Returns the notification preferences objdect
   */
  function create() {
    let associationId = Session.activeState.association.id;
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/email/operator-preference/', associationId)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update notification preferences for artists
   * @param {number} id The ID of the notification preferences to update
   * @param {object} notPrefs The notification preferences to update
   * @return {object} Returns the updated notification preferences
   */
  function update(id, notPrefs) {
    return $http.put(ENDPOINT.server +
    'collectors/api/v1.1/email/operator-preference/' + id + '/', notPrefs)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return OperatorNotificationPrefs;
}

angular
  .module('inkfinder')
  .factory('OperatorNotificationPrefs', OperatorNotificationPrefs);



// WEBPACK FOOTER //
// ./components/shop/operators/notification-prefs/operator-notification-prefs.service.js